import { CollectionAsset } from './collection-asset';

const hasMatchingProperty = (
  property: string,
  a: CollectionAsset,
  b: CollectionAsset,
) => a[property] === b[property];

const hasMatchingId = (a: CollectionAsset, b: CollectionAsset): boolean => hasMatchingProperty('sourceAssetId', a, b);

const hasMatchingAssetType = (
  a: CollectionAsset,
  b: CollectionAsset,
): boolean => hasMatchingProperty('assetType', a, b);

export const isMatchingAsset = (
  a: CollectionAsset,
): ((b: CollectionAsset) => boolean
  ) => (b: CollectionAsset): boolean => hasMatchingId(a, b) && hasMatchingAssetType(a, b);
